import {
    IonAlert,
    IonButton,
    IonCheckbox,
    IonInput,
    IonItem,
    IonLabel,
    IonList,
} from '@ionic/react';
import React from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import { FieldError, NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../../components/common';
import Layout from '../../components/layout';
import Mobiscroll from '../../components/mobiscroll';
import PasswordInput from '../../components/passwordInput';
import Loading from '../../components/spinner';
import moment from '../../lib/moment';
import { withTranslation } from '../../lib/translate';
import { forwardTo, forwardToLegalPage, getDefaultRoute, isWebConfig, openExternalLink, validateForm } from '../../lib/utils';
import {

    registerRequest,
    setModal,
    setRegisterForm,
    setSysLocale,
} from '../../store/actions';
import { CLEAR_REGISTER_FORM } from '../../store/constants';
import './index.css';
import { Device } from '@capacitor/device';
import MobileInput from '../../components/mobileInput';
import FieldWrapper from '../../components/fieldWrapper';
import { hexToRGBA } from '../../lib/colorUtils';
import Slider, { Slide } from '../../components/slider';

const { DatePicker, SelectOption } = Mobiscroll;

class LoyaltyRegister extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formErrors: {},
            fromGiftVoucher: this.props?.location?.state?.fromGiftVoucher,
            dietaryRequirements: [],
            mobile_code: '',
            mobile_value: '',
            pickerVisible: false,
            email: props.registerFormData?.email || '',
            primaryColor: '#000000'
        };
        this.handleInput = this.handleInput.bind(this);
        this.handleRegister = this.handleRegister.bind(this);
        this.navToTerms = this.navToTerms.bind(this);
        this.formConfig = {
            first_name: { type: 'name', required: getConfig().flags.hasFullNameOnRegister ? getConfig().flags.hasFullNameOnRegister : false },
            last_name: { type: 'name', required: getConfig().flags.hasFullNameOnRegister ? getConfig().flags.hasFullNameOnRegister : false },
            mobile: { type: 'tel', required: getConfig().flags.hasMobileOnRegister ? getConfig().flags.hasMobileOnRegister : false },
            email: { type: 'email', required: true },
            password: { type: 'password', required: true },
            accepted_terms_and_conditions: { type: 'toggle', toggle: true },
            birthday: { type: 'birthday', required: getConfig().restrictions?.min_registration_age ? true : false },
            referral_code: { type: 'text', required: false },
            favourite_location: { type: 'text', required: getConfig().flags.hasRestaurantPreferenceSelector ? true : false },
            postal_code: { type: 'text', required: false },

        };
    }

    handleInput(key, val) {
        const { dispatch } = this.props;
        this.setState({ formErrors: { ...this.state.formErrors, [key]: '' } }, () => {
            dispatch(setRegisterForm(key, val));
            if (key === 'accepted_terms_and_conditions') {
                let formErrors = { ...this.state.formErrors };
                formErrors.accepted_terms_and_conditions = undefined;
                this.setState({ formErrors });
            }
        })
    }

    handleRegister() {
        setRegisterForm({ 'email': this.state.email })
        const { registerFormData } = this.props;
        registerFormData.email = this.state.email
        let formErrors = validateForm(this.formConfig, registerFormData);
        if (registerFormData.repeatPassword !== registerFormData.password) {
            formErrors.repeatPassword = "Passwords are not same";
        }
        this.setState({ formErrors });
        if (Object.keys(formErrors).length === 0) {
            const hideAboutUs = getConfig().flags.hasFullNameOnRegister && getConfig().flags.hasMobileOnRegister && getConfig().restrictions?.min_registration_age;

            let referrer;
            if (this.props?.location?.state?.referrer) {
                referrer = this.props?.location?.state?.referrer;
            } else if (hideAboutUs) {
                referrer = undefined;
            } else {
                referrer = '/register';
            }

            this.props.dispatch(registerRequest({ referrer, fromLoyaltyPage: true }));
        }
    }

    componentDidMount() {

        const { colors } = this.props.clientStyles;
        if (colors['--ion-color-primary']) {
            this.setState({ primaryColor: colors['--ion-color-primary'] });

        }


        this.props.dispatch(setRegisterForm('accepted_terms_and_conditions', true));
        if (getConfig().flags?.hasMarketingOptInChecked) {
            this.props.dispatch(setRegisterForm('is_subscribed', true));

        }
        Device.getLanguageCode().then((res) => {
            const sysLocale = res.value.substr(0, 2);
            if (sysLocale) {
                this.props.dispatch(setSysLocale(sysLocale));
            }
        });

        if (getConfig().flags.hasPromoCodeOnRegister) {
            let params = new URLSearchParams(document.location.search);
            if(params.get('promo_code')){
            this.props.dispatch(setRegisterForm('promo_code', params.get('promo_code').toUpperCase()));
            }
        }
        if (getConfig().flags.hasRestaurantPreferenceSelector) {
            const publishedRestaurants = this.props.restaurants.filter(el => el.is_published);
            if (publishedRestaurants.length === 1) {
                this.props.dispatch(setRegisterForm('favourite_location', publishedRestaurants[0].name));
            }
        }
    }

    componentWillUnmount() {
        this.props.dispatch(setRegisterForm('email', this.state.email));
    }

    returnToLogin = (history) => history.goBack();

    navToTerms = () => forwardToLegalPage('/terms');




    formatDataForSelect = (langs) => {
        const { __ } = this.props;
        let arrForSelect = [];
        Object.keys(langs).forEach((key) => {
            arrForSelect.push({ text: __(langs[key]), value: key });
        });
        return [{ text: '', value: null }, ...arrForSelect];
    };
    formatDataForCheckBox = (data) => {
        const { __ } = this.props;
        let arrForSelect = [];
        Object.keys(data).forEach((key) => {
            arrForSelect.push({ text: __(data[key]), value: key });
        });
        return arrForSelect;
    };
    setMobileCode = (val) => {
        const { dispatch } = this.props;
        this.setState({ mobile_code: val });
        dispatch(setRegisterForm('mobile_code', val));
    };
    setMobileValue = (val) => {
        const { dispatch } = this.props;
        this.setState({ mobile_value: val }, () => {
            this.handleInput('mobile_value', val);
            if (val == '') {
                dispatch(setRegisterForm('mobile', ''));
            } else {
                dispatch(setRegisterForm('mobile', `${this.state.mobile_code}${val}`));
            }
        });
    };

    handleOnBeforeShow = () => {
        if (!this.state.pickerVisible) {
            this.setState({ pickerVisible: true })
        }
    }
    handleOnBeforeClose = () => {
        if (this.state.pickerVisible) {
            this.setState({ pickerVisible: false })
        }
    }
    shouldComponentUpdate = () => {
        return !this.state.pickerVisible;
    }
    render() {
        const { __, isRegisterModalOpen, registerFormData, dispatch } = this.props;
        const { dietaryRequirements, email } = this.state;
        const defaultDateValue = moment().subtract(getConfig().restrictions?.min_registration_age || 18, 'years');
        const password = registerFormData.password;
        const repeatPassword = registerFormData.repeatPassword || "";
        const first_name = registerFormData.first_name;
        const last_name = registerFormData.last_name;
        const mobile = registerFormData.mobile;
        const is_subscribed = registerFormData.is_subscribed;
        const birthday = registerFormData.birthday;
        const mobile_code = registerFormData.mobile_code;
        const mobile_value = registerFormData.mobile_value;
        const gender = registerFormData.gender;
        const postal_code = registerFormData.postal_code
        const favourite_location = registerFormData.favourite_location
        const promo_code = registerFormData.promo_code
        const referral_code = registerFormData.referral_code
        const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
        const locale = getConfig().localization.defaultLocale
        const languages = Object.keys(getConfig().localization.supportedLocales);
        const hasGenderSelector = getConfig().flags.hasGenderSelector;
        const genderList = this.formatDataForSelect(getConfig().genders || { male: 'Male', female: 'Female' });
        const hasDietaryRequirements = getConfig().flags.hasDietaryRequirements;
        const dietaryRequirementsList = this.formatDataForCheckBox(getConfig().dietaryRequirements || { vegan: 'Vegan', glutenFree: 'Gluten free', none: 'None' });
        const loyaltyData = getConfig().loyalty_signup_content || {}
        return (
            <Loading>
                <div className="absolute-content scrollable-y loyalty-register-page">
                    <div className='centered'>
                        {loyaltyData?.title && <Title className='page-title-centered'>{__(loyaltyData.title)}</Title>}
                        {loyaltyData?.description && <NormalText className='page-title-centered'>{__(loyaltyData.description)}</NormalText>}
                    </div>
                    <Spacer size={2} />

                    {(loyaltyData?.banner_images || []).length > 0 &&
                        <div className='banner-slider'>
                            <Slider
                                settings={{
                                    slidesPerView: isWebConfig()?1.8:1.1,
                                    centeredSlides: true,
                                    spaceBetween: 10,
                                    initialSlide: 0,
                                    autoplay: {
                                        disableOnInteraction: false,
                                    },
                                    pagination: {
                                        clickable: false,
                                    },
                                    loop:loyaltyData.banner_images.length>=5
                                }}
                            >
                                {loyaltyData.banner_images.map((item, i) => (
                                    <Slide className={`slide-${i}`} key={i}><img src={item} /></Slide>
                                ))}
                                <div className="swiper-pagination"></div>
                            </Slider>
                            {this.state.newsModalOpened &&
                                <Modal
                                    isOpen={this.state.newsModalOpened}
                                    onDidDismiss={() => this.setState({ newsModalOpened: false, selectedNews: null })}>

                                    <div className="lefted">
                                        <Title className='modal-title'>{this.state.selectedNews?.title}</Title>
                                        <div dangerouslySetInnerHTML={{ __html: this.state.selectedNews?.content }}></div>
                                    </div>
                                </Modal>
                            }
                            <Spacer size={2} />
                        </div>
                    }


                    {(loyaltyData?.perks || []).length > 0 &&
                        <>
                            <div className='loyalty-perks'>

                                {loyaltyData?.perks.map(perk => (
                                    <div>
                                        {perk?.icon &&
                                            <>
                                                <div style={{ backgroundColor: hexToRGBA(this.state.primaryColor, 0.3, true) }} className='loyalty-perk-image-wrapper'>
                                                    <img src={perk.icon} />

                                                </div>
                                                <Spacer size={1} />
                                            </>
                                        }
                                        {perk?.title &&
                                            <>
                                                <StrongText>{__(perk.title)}</StrongText>
                                                <Spacer size={0} /></>
                                        }
                                        {perk?.description &&
                                            <SmallText>{__(perk.description)}</SmallText>

                                        }
                                    </div>
                                ))}
                            </div>
                            <Spacer size={5} />
                        </>
                    }

                    <div>
                        <IonList>
                            {getConfig().flags.hasFullNameOnRegister && (
                                <div className="input-field-container input-field-container-multiple">
                                    <StrongText className="primary-color">{__('Your name')}</StrongText>
                                    <div>
                                        <FieldWrapper error={this.state.formErrors.first_name}>
                                            <IonInput
                                                autocapitalize='on'
                                                placeholder={__('First name')}
                                                onIonInput={(e) => this.handleInput('first_name', e.target.value)}
                                                type="text"
                                                pattern="text"
                                                inputmode="text"
                                                value={first_name}
                                                selenium="firstName"
                                            ></IonInput>
                                        </FieldWrapper>

                                    </div>

                                    <div>
                                        <FieldWrapper error={this.state.formErrors.last_name}>
                                            <IonInput
                                                autocapitalize='on'
                                                placeholder={__('Last name')}
                                                onIonInput={(e) => this.handleInput('last_name', e.target.value)}
                                                type="text"
                                                pattern="text"
                                                inputmode="text"
                                                value={last_name}
                                                selenium="lastName"
                                            ></IonInput>
                                        </FieldWrapper>

                                    </div>
                                </div>
                            )}

                            <div className="input-field-container">
                                <StrongText className="primary-color">{__('Your email address')}</StrongText>
                                <FieldWrapper error={this.state.formErrors.email}>
                                    <IonInput
                                        clearInput={!this.state.formErrors.email}
                                        placeholder={__('Email address')}
                                        onIonInput={(e) => { this.setState({ 'email': e.target.value }) }}
                                        type="email"
                                        pattern="email"
                                        inputmode="email"
                                        value={email}
                                        autocomplete="email"
                                    ></IonInput>
                                </FieldWrapper>

                            </div>
                            <div className="input-field-container input-field-container-multiple">
                                <StrongText className="primary-color">{__('Set a password')}</StrongText>
                                <SmallText>{__('Your password should contain')}</SmallText>
                                <Spacer size={0} />
                                <div style={{ margin: 0, paddingLeft: 'var(--ion-padding)' }}>
                                    <SmallText>{`• ${__('at least 8 characters')}`}</SmallText>
                                    <SmallText>{`• ${__('1 uppercase letter')}`}</SmallText>
                                    <SmallText>{`• ${__('1 lowercase letter')}`}</SmallText>
                                    <SmallText>{`• ${__('1 number')}`}</SmallText>
                                    <SmallText>{`• ${__('1 special symbol (e.g., !@#$%^&*)')}`}</SmallText>
                                </div>
                                <Spacer size={2} />
                                <FieldWrapper error={this.state.formErrors.password}>
                                    <PasswordInput
                                        showPasswordToggle={!this.state.formErrors.password}
                                        placeholder={__('Password')}
                                        onIonChange={(e) => this.handleInput('password', e.target.value)}
                                        value={password}
                                    />
                                </FieldWrapper>
                                <FieldWrapper error={repeatPassword !== password ? "Passwords are not the same" : ""}>
                                    <PasswordInput
                                        showPasswordToggle={repeatPassword == password}
                                        placeholder={__('Re-enter your password')}
                                        onIonChange={(e) => this.handleInput('repeatPassword', e.target.value)}
                                        value={repeatPassword}
                                    />
                                </FieldWrapper>
                            </div>
                            {getConfig().flags.hasMobileOnRegister &&
                                <>
                                    {getConfig().flags.hasMobileCountryCode ? (
                                        <div className="input-field-container">
                                            <StrongText className="primary-color">{__('Mobile number')}</StrongText>

                                            <MobileInput error={this.state.formErrors.mobile} mobile_code={mobile_code} mobile_value={mobile_value} setMobileCode={this.setMobileCode} setMobileValue={this.setMobileValue} />

                                        </div>
                                    ) : (
                                        <div className="input-field-container">
                                            <StrongText className="primary-color">{__('Mobile number')}</StrongText>
                                            <FieldWrapper error={this.state.formErrors.mobile}>
                                                <IonInput
                                                    placeholder={__('Mobile number')}
                                                    onIonInput={(e) => this.handleInput('mobile', e.target.value)}
                                                    required={true}
                                                    type="tel"
                                                    pattern="tel"
                                                    inputmode="tel"
                                                    onKeyPress={(e) => {
                                                        const reqexFormat = mobile ? '^[0-9]+$' : '^[+0-9]+$';
                                                        let regex = new RegExp(reqexFormat);
                                                        if (regex.test(e.key)) {
                                                            return true;
                                                        }
                                                        e.preventDefault();
                                                        return false;
                                                    }}
                                                    value={mobile}
                                                ></IonInput>
                                            </FieldWrapper>

                                        </div>
                                    )}


                                </>
                            }

                            {getConfig().restrictions?.min_registration_age ? (
                                <>
                                    <div className="input-field-container">
                                        <StrongText className="primary-color">{__('Date of birth')}</StrongText>
                                        <FieldWrapper error={this.state.formErrors.birthday}>
                                            <DatePicker
                                                onBeforeShow={this.handleOnBeforeShow}
                                                onBeforeClose={this.handleOnBeforeClose}
                                                theme='ios'
                                                placeholder={__('Date of birth')}
                                                cssClass={`${isWebConfig() ? 'web' : ''} date-picker`}
                                                display="center"
                                                max={yesterday}
                                                min={new Date().getFullYear() - (getConfig().restrictions?.max_registration_age || 85)}
                                                defaultValue={defaultDateValue}
                                                setText={__('Done')}
                                                cancelText={__('Cancel')}
                                                value={birthday}
                                                onSet={(e, a) => this.setState({ pickerVisible: false }, () => this.handleInput('birthday', a.element.value))}
                                                dateFormat="dd/mm/yy"
                                            />
                                        </FieldWrapper>
                                        <NormalText className='date-of-birth-description'>{__(`You must be over ${getConfig().restrictions?.min_registration_age} years old to register`)}</NormalText>
                                    </div>


                                </>
                            ) : null}
                            {getConfig().flags.hasReferralCodeOnRegister ? (
                                <>
                                    <div className="input-field-container">
                                        <StrongText className="primary-color">{__('Referral code')}</StrongText>
                                        <FieldWrapper>
                                            <IonInput
                                                placeholder={__('Referral code')}
                                                onIonInput={(e) => this.handleInput('referral_code', e.target.value)}

                                                type="text"
                                                pattern="text"
                                                inputmode="text"
                                                value={referral_code}
                                                selenium="referralCode"
                                            ></IonInput>
                                        </FieldWrapper>
                                    </div>
                                </>
                            ) : null}
                            {getConfig().flags.hasRestaurantPreferenceSelector &&
                                <div className="input-field-container">
                                    <StrongText className="primary-color">{__('Favourite location')}</StrongText>
                                    <FieldWrapper dropdown error={this.state.formErrors.favourite_location}>
                                        <SelectOption
                                            onBeforeShow={this.handleOnBeforeShow}
                                            onBeforeClose={this.handleOnBeforeClose}
                                            theme='ios'
                                            cssClass={`${isWebConfig() ? 'web' : ''} restaurant-selection`}
                                            display="center"
                                            onSet={(event, data) => this.handleInput('favourite_location', data.getVal())}
                                            data={[{ value: '', text: '' }, ...this.props.restaurants.filter(el => el.is_published).map(el => ({ value: el.name, text: el.name }))]}
                                            label="Location"
                                            value={favourite_location}
                                            inputStyle="box"
                                            placeholder={__('Select your favourite location')}
                                            cancelText={__('Cancel')}
                                            setText={__('OK')}
                                        />
                                    </FieldWrapper>
                                </div>

                            }
                            {getConfig().flags.hasPromoCodeOnRegister &&
                                <div className='input-field-container'>
                                    <StrongText>{__('Promo code')}</StrongText>
                                    <FieldWrapper>
                                        <IonInput
                                            placeholder={__('Promo code')}
                                            onIonInput={(e) => this.handleInput('promo_code', e.target.value.toUpperCase())}
                                            type="text"
                                            pattern="text"
                                            inputmode="text"
                                            value={promo_code}
                                        ></IonInput>
                                    </FieldWrapper>
                                </div>
                            }
                            {getConfig().flags.hasPostalCodeSelector &&
                                <div className='input-field-container'>
                                    <StrongText>{__('Postcode')}</StrongText>
                                    <FieldWrapper>
                                        <IonInput
                                            placeholder={__('Postcode')}
                                            onIonInput={(e) => this.handleInput('postal_code', e.target.value)}
                                            type="text"
                                            pattern="text"
                                            inputmode="text"
                                            value={postal_code}
                                        ></IonInput>
                                    </FieldWrapper>
                                </div>

                            }
                            {hasGenderSelector ? (
                                <>
                                    <div className="input-field-container">
                                        <StrongText className="primary-color">{`${__('Gender')} (${__('optional')})`}</StrongText>
                                        <FieldWrapper dropdown>
                                            <SelectOption
                                                theme='ios'
                                                cssClass={isWebConfig() ? 'web' : ''}
                                                display="center"
                                                onSet={(event, data) => this.handleInput('gender', data.getVal())}
                                                data={genderList}
                                                label="Location"
                                                value={gender}
                                                inputStyle="box"
                                                placeholder={__('Select one')}
                                                cancelText={__('Cancel')}
                                                setText={__('OK')}
                                            />
                                        </FieldWrapper>
                                    </div>


                                </>
                            ) : null}
                            {getConfig().flags.hasLanguageSelectionOnRegister && <>
                                {languages.length <= 1 ? null : (
                                    <>

                                        <div className="input-field-container">
                                            <StrongText className="primary-color">{__('Language')}</StrongText>
                                            <FieldWrapper dropdown>
                                                <SelectOption
                                                    theme='ios'
                                                    cssClass={isWebConfig() ? 'web' : ''}
                                                    display="center"
                                                    onSet={(e, data) => this.handleInput('locale', data.getVal())}
                                                    data={this.formatDataForSelect(getConfig().localization.supportedLocales)}
                                                    label="Location"
                                                    value={locale}
                                                    inputStyle="box"
                                                    placeholder={__('Select one')}
                                                    cancelText={__('Cancel')}
                                                    setText={__('OK')}
                                                />
                                            </FieldWrapper>
                                        </div>


                                    </>
                                )}

                            </>}
                            <div className='input-field-container input-field-checkboxes'>

                                {hasDietaryRequirements && <StrongText>{`${__('Dietary requirements')} (${__('optional')})`}</StrongText>}
                                {hasDietaryRequirements ?
                                    dietaryRequirementsList.map((dietaryReq, index) => (
                                        <IonItem lines="none" key={index}>
                                            <div tabIndex="-1"></div>
                                            <IonCheckbox

                                                slot="start"
                                                checked={dietaryRequirements.includes(dietaryReq.value)}
                                                onIonChange={(e) => {
                                                    if (e.detail.checked && !dietaryRequirements.includes(dietaryReq.value)) {
                                                        dietaryRequirements.push(dietaryReq.value);
                                                        this.setState({ dietaryRequirements });
                                                        this.handleInput('dietary_requirements', dietaryRequirements);
                                                    } else if (!e.detail.checked) {
                                                        this.setState({ dietaryRequirements: dietaryRequirements.filter(e => e !== dietaryReq.value) });
                                                        this.handleInput('dietary_requirements', dietaryRequirements.filter(e => e !== dietaryReq.value));
                                                    }
                                                }}
                                            />
                                            <NormalText>
                                                {__(dietaryReq.text)}
                                            </NormalText>
                                        </IonItem>
                                    )) : null
                                }
                            </div>

                        </IonList>
                        <IonList>

                            <div lines="none">
                                <div tabIndex="-1"></div>
                                <div className="toggle">
                                    <IonLabel>
                                        <div className="register-terms-wrapper">
                                            <IonCheckbox
                                                color='secondary'
                                                checked={is_subscribed}
                                                onIonChange={(e) =>
                                                    this.handleInput('is_subscribed', e.detail.checked)
                                                }
                                            />
                                            <IonLabel className="ion-text-wrap">
                                                <NormalText color="primary">
                                                    {__(
                                                        "I'd like to receive email updates that contain news, offers and promotions",
                                                    )}
                                                </NormalText>
                                            </IonLabel>
                                        </div>
                                    </IonLabel>
                                </div>
                            </div>
                        </IonList>
                        <Spacer size={5} />
                        <IonButton
                            expand="block"
                            color="primary"
                            className="register-button button-uppercase"
                            onClick={() => this.handleRegister()}
                        >
                            {__('Continue')}
                        </IonButton>
                        <Spacer size={2} />
                        <IonLabel className="ion-text-wrap centered">
                            <NormalText color="primary">
                                {__('By signing up you agree to our') + ' '}{' '}
                                <span
                                    className="legal-pages-btn bold button pointer secondary-color link"
                                    onClick={() => getConfig().general.customTermsLink ? openExternalLink(getConfig().general.customTermsLink) : forwardToLegalPage('/terms')}
                                >
                                    {__('terms and conditions')}
                                </span>{' '}
                                {__('and')}{' '}
                                <span
                                    className="legal-pages-btn bold button pointer secondary-color link"
                                    onClick={() => getConfig().general.customPrivacyLink ? openExternalLink(getConfig().general.customPrivacyLink) : forwardToLegalPage('/privacy')}

                                >
                                    {__('privacy policy')}
                                </span>
                            </NormalText>
                        </IonLabel>
                        <Spacer size={5} />
                        <div className=" centered">
                            <NormalText className="centered block">{__("Already have an account?")}</NormalText>
                            <IonButton
                                color='secondary'
                                className="link"
                                onClick={() => forwardTo('/login')}
                            >
                                {__('Login')}
                            </IonButton>
                        </div>
                    </div>

                </div>

                <IonAlert
                    isOpen={isRegisterModalOpen}
                    onDidDismiss={() => this.props.dispatch(setModal('isRegisterModalOpen', false))}
                    header={__('Success')}
                    message={__('Register processed. Please check your mail')}
                    buttons={[
                        {
                            text: __('Close'),
                            role: 'cancel',
                            cssClass: 'secondary',
                            handler: () => this.props.dispatch(setModal(('isRegisterModalOpen', false))),
                        },
                    ]}
                />
            </Loading>
        );
    }
}

const stateToProps = (state) => {
    const { auth, isRegisterModalOpen, registerFormData } = state.profile;
    const { navConfig, clientStyles } = state.common;
    const { restaurants } = state.restaurants
    return {
        auth,
        isRegisterModalOpen,
        registerFormData,
        navConfig,
        restaurants,
        clientStyles
    };
};

export default connect(stateToProps)(withTranslation(LoyaltyRegister));
